//@flow

import React from 'react';
import { object, string } from 'yup';
import { Formik, FormikValues } from 'formik';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Button, FormGroup, Label } from 'reactstrap';

import { CustomCounter, WhitePanel } from '../../../components';
import { LodgeDateRangePicker } from '../Common';
import { setCookies15Mins, getFromCookies } from '../helpers';

type Props = RouteComponentProps & {
  onSuccess: () => void,
};

const schema = object().shape({
  checkinDate: string().required('Please enter your checkin date'),
  checkoutDate: string().required('Please enter your checkout date'),
});

const CheckAvailability = (props: Props) => (
  <Formik
    validationSchema={schema}
    initialValues={getFromCookies()}
    onSubmit={(values: FormikValues) => {
      setCookies15Mins(values);

      props.onSuccess();
      props.history.push(props.location.pathname);
    }}
  >
    {({ handleSubmit }) => {
      return (
        <WhitePanel>
          <h2>Check Availability</h2>
          <section className="select__date">
          <div className="select__date_checkin_checkout">
            <FormGroup>
              <Label>Start Date - End Date</Label>
              <LodgeDateRangePicker name="checkinDate" />
            </FormGroup>
          </div>
          <div className="select__date_guest">
            <CustomCounter title="No. of people(PAX)" />
          </div>
          <div className="select__date_action">
            <Label style={{ visibility: 'hidden' }}>Submit button</Label>
            <Button color="yellow" onClick={handleSubmit} id="lodges-check-availability-btn">
              Check Availability
            </Button>
          </div>
        </section>
        </WhitePanel>
      );
    }}
  </Formik>
);

CheckAvailability.defaultProps = {
  onSuccess: () => { },
};

export default withRouter(CheckAvailability);



// WEBPACK FOOTER //
// ./src/screens/Lodge/Details/CheckAvailability.js